import { Component, Input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-username-password',
  templateUrl: './userapi-username-password.component.html'
})
export class UserApiUsernamePasswordComponent extends AbstractUserApiModalComponent {
  @Input() userApi: UserAPI;

  showPassword = false;
}
